import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { Url_Friendly_String } from '../../helpers/helper';

@Injectable({
  providedIn: 'root',
})
export class ProductDetailUrlGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const name = route.paramMap.get('name');
    if (name && name.includes(' ')) {
      const id = route.paramMap.get('id');
      const correctedName = Url_Friendly_String(name);
      this.router.navigate(['/product', id, correctedName], {
        replaceUrl: true,
      });
      return false;
    }
    return true;
  }
}
